<template>
  <div class="home-container flex spaced column">
    <div class="top-img">
      <div class="overlay overblue"></div>
      <img src="../assets/images/home/homepage_main.jpg" alt="">
    </div>
    <div class="content-top text-white row flex align-end">
      <div class="page-title content-padded">
        The Ultimate Settlements Engine Powering Business Intelligence
      </div>
      <div class="uppercase flex wrap">
        <div class="content-padded content-mintext">
          >  Revenue Collection
        </div>
        <div class="content-padded content-mintext">
          >  Payment Aggregation
        </div>
        <div class="content-padded content-mintext">
          >  Business Intelligence
        </div>
      </div>
    </div>
    <div class="dark-blue text-white row flex column">
      <div class="content-padded content-maintext column flex">
        The future of settlements is digitally driven, efficient, secure and transparent. <br/><span class="linkesque">Harness this power today</span>
      </div>
      <div class="flex wrap spaced content-padded">
        <div class="content-padded content-subtext work-text third-width container top-rule">
          Pesaflow is a merchant-centric, fintech powered settlement engine that offers the complete power of a bank to any establishment
        </div>
        <div class="content-padded content-subtext work-text third-width container top-rule">
          By enhancing collection of revenue and reducing leakages, Pesaflow saves expenditure and ensures convenience
        </div>
        <div class="content-padded content-subtext work-text third-width container top-rule">
          Receive and disburse funds through multiple channels without worrying about the overhead of managing separate float accounts
        </div>
      </div>
      <div class="content-padded">
        <div class="">
          Solutions
        </div>
        <div class="flex wrap spaced">
          <router-link to="governments" tag="div" class="flex div-breaks content-margin equal-width right-margin pointer">
            <div class="">
              <img src="../assets/images/home/homepage_1.svg" alt="">
            </div>
            <div class="spaced column flex solutions-action">
              <div class="">
                Governments & <br class="mobile-only"/> Public Sector
              </div>
              <div class="linkesque">
                Learn more
              </div>
            </div>
            <div class="center-content flex solutions-arrow">
              &rarr;
            </div>
          </router-link>
          <router-link to="merchant" tag="div" class="flex div-breaks content-margin equal-width pointer">
            <div class="">
              <img src="../assets/images/home/homepage_2.svg" alt="">
            </div>
            <div class="spaced column flex solutions-action">
              <div class="">
                Merchants
              </div>
              <div class="linkesque">
                Learn more
              </div>
            </div>
            <div class="center-content flex solutions-arrow">
              &rarr;
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="row content-spaced text-blue white">
      <div class="content-margin">
        <div class="content-maintext content-padded">
          Gain control over all <br/>financial transactions <br/>easily and securely
        </div>
        <div class="wrap flex">
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/home/homepage_3.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Complete Payment Transparency
            </div>
            <div class="content-subtext content-padded">
              Pesaflow enables real-time settlements and reconciliations by enabling payments to various parties through virtual accounts.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/home/homepage_4.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Actionable Financial Information
            </div>
            <div class="content-subtext content-padded">
              Pesaflow provides data and gives analytics that give insights on trends specific to services or customers.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/home/homepage_5.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Global Visibility & Tighter Controls
            </div>
            <div class="content-subtext content-padded">
              With complete control to track and manage settlements, Pesaflow offers comprehensive reporting and management all in one.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row content-spaced text-blue light-blue">
      <div class="content-padded content-subtitle uppercase">
        Proud achievements
      </div>
      <div class="content-maintext content-padded">
        Over 5 years of powering payment collections for governments
      </div>
      <div class="flex wrap content-margin">
        <div class="content-padded content-shout">
          13 million <span class="text-yellow">+</span>
        </div>
        <div class="content-subtext content-padded work-text equal-width container top-rule">
          Kenyan Citizens count on eCitizen Kenya to conduct their payment transactions for Government services
        </div>
      </div>
      <div class="content-padded flex wrap spaced">
        <div class="flex content-padded">
          <div class="stats-desc flex center-content stats-circled">4</div>
          <div class="content-subtext flex center-content">
            Government <br class="desktop-only"/>Departments
          </div>
        </div>
        <div class="flex content-padded">
          <div class="stats-desc flex center-content stats-circled">3</div>
          <div class="content-subtext flex center-content">
            County <br class="desktop-only"/>Governments
          </div>
        </div>
        <div class="flex content-padded">
          <div class="stats-desc flex center-content stats-circled">217</div>
          <div class="content-subtext flex center-content">
            Government <br class="desktop-only"/>Services
          </div>
        </div>
      </div>
      <div class="flex wrap">
        <div class="content-shout content-padded">
          $40 million <span class="text-yellow">+</span>
        </div>
        <div class="content-subtext content-padded work-text equal-width container top-rule">
          Amount of revenue collected <br/>to date for the Kenyan <br/>Government
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img">
        <div class="overlay dark-blue"></div>
        <img src="../assets/images/home/homepage_6.png" alt="">
      </div>
      <div class="row text-white container">
        <div class="top-spaced content-maintext content-padded content-slim">
          Your success and growth <br class="desktop-only"/>are our top priority
        </div>
        <div class="content-subtext content-padded content-slim">
          Our teams are available to help, every <br class="desktop-only"/>step of the way
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img med-blue">
        <img src="../assets/images/home/homepage_7.png" alt="">
      </div>
      <div class="row content-margin flex wrap spaced container">
        <div class="content-padded content-maintext">
          Scale your business or <br class="desktop-only"/>organization by tapping into <br class="desktop-only"/>
          the same powerful tools <br class="desktop-only"/>trusted by governments
        </div>
        <div class="content-padded vertical-center flex">
          <button type="button" name="button" class="dark-blue text-white talk-btn">Talk to us today</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint max-len: 0 */
export default {
  name: 'Home',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home-img {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  img {
    width: 100%;
    height: 100vh;
    object-fit: cover;
  }
}
.work-text {
  font-family: 'Work Sans';
}
.content-shout {
  font-size: 40px;
  line-height: 40px;
}
.stats-circled {
  width: 64px;
  height: 64px;
  border: 1px solid #0187FB;
  border-radius: 50%;
  margin-right: 20px;
}
.stats-desc
{
  font-size: 31px;
  line-height: 40px;
}
.solutions-action {
  font-weight: bold;
  padding-left: 20px;
  justify-content: space-evenly;
}
.solutions-arrow {
  font-size: 50px;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
}
@media only screen and (min-width: 1024px) {
  .content-top {
    width: 70%;
    justify-content: flex-end;
  }
  .page-title
  {
    font-size: 80px;
    line-height: 80px;
  }
  .stats-img {
    width: 70px;
    height: 50px;
  }
  .content-shout {
    font-size: 90px;
    flex: 1.5;
    line-height: 90px;
  }
  .solutions-action {
    align-items: flex-start;
    padding-left: 20px;
    justify-content: space-around;
    flex: 1;
  }
  .solutions-arrow {
    padding: 0px 0px 20px 35px;
    font-size: 40px;
  }
  .right-margin {
    margin-right: 10%;
  }
}
</style>
